// Un solo escuchador del cursor para todos los avatares de la página (cada AgentDot se suscribe). Respeta «reducir movimiento».
const subs = new Set();
let pointer = null;
let raf = 0;
let bound = false;

const reduced = () => typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
const flush = () => { raf = 0; subs.forEach((fn) => fn(pointer)); };
const schedule = () => { if (!raf) raf = requestAnimationFrame(flush); };
const onMove = (e) => { pointer = { x: e.clientX, y: e.clientY }; schedule(); };
const onLeave = () => { pointer = null; schedule(); };

function bind() {
  if (bound || reduced()) return;
  bound = true;
  window.addEventListener('pointermove', onMove, { passive: true });
  document.documentElement.addEventListener('pointerleave', onLeave);
}
function unbind() {
  if (!bound) return;
  bound = false;
  window.removeEventListener('pointermove', onMove);
  document.documentElement.removeEventListener('pointerleave', onLeave);
}

/** `fn(pointer|null)` se llama al mover el cursor y al suscribirse. Devuelve la función para darse de baja. */
export function trackPointer(fn) {
  subs.add(fn);
  bind();
  fn(pointer);
  return () => { subs.delete(fn); if (!subs.size) unbind(); };
}
export const hasPointer = () => pointer !== null;
